/**
      *********************************************************
      Description: Textbox component. .
      Required props:  type,value.
      limitations    : N/A.
      *********************************************************
**/

import { Tooltip,Typography } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React from "react";
import OtpInput from 'react-otp-input';
import DefaultSettings from './settings';
import { getEnvVariable } from '../../../modules/environmentalList';

export default function OtpInputComp(props) {
    const { value, handleFieldValue, extraProps, disabled, error, required, fullWidth, tooltip, max, contexthelp, length, ...otherProps } = props
    const { label, helperText, name } = otherProps;

    const handleChange = (otp) => {
        let tempval = otp ? otp.replace(/[^\w\s]/gi, "") : null;
        if (tempval)
            handleFieldValue({ target: { value: tempval, name: name, checked: false }, currentTarget: { dataset: null } })

    }
    let tlabel = <Typography variant='subtitle2' color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
        {tooltip && <Tooltip title={tooltip ? tooltip : null}
            placement="bottom-start" >
            <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        </Tooltip>}
    </Typography>

    return (
        <FormControl className={name} fullWidth={fullWidth ? fullWidth : true} error={error} >
            <InputLabel shrink>  {tlabel}&nbsp;
                 </InputLabel>&nbsp;
            <OtpInput
            disabled={disabled || false}            
            //fullWidth={fullWidth ? fullWidth : true}
            label={tlabel}
                className="text-secondary"
                style={{ color: 'grey' }}
                value={value}
                onChange={(otp) => { handleChange(otp) }}
                numInputs={max || 1}
                separator={<p>&nbsp;</p>}
                inputStyle={{ width: '2em', height: '2em' }}
                isDisabled={disabled}
                hasErrored={error}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    )
}